module.exports = __webpack_public_path__ + "img/jbq1.9c238c0b.gif";